<script lang="ts">
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import { ButtonVariant } from "@components/common/ButtonVariant.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import SideModal from "@components/common/SideModal.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import cofeeBeanIcon from "@core/assets/icons/cofee-bean.svg?raw";
	import { CategoryType } from "@core/schema/CategoryType.js";
	import { getCartPath } from "@core/schema/paths/getCartPath.js";
	import { getCategoryPath } from "@core/schema/paths/getCategoryPath.js";
	import { createReactiveBreakpoint } from "@core/utils/createReactiveBreakpoint.js";
	import { formatPrice } from "@core/utils/formatPrice.js";
	import { Cart } from "../../cart/Cart.svelte.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import CartClosestBenefit from "./CartClosestBenefit.svelte";
	import translations from "./CartOverviewModal.translations.json" with { type: "json" };
	import CartOverviewProduct from "./CartOverviewProduct.svelte";

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);

	const isDesktop = createReactiveBreakpoint(">2xl");
</script>

<SideModal heading={translate("cartTitle")} bind:show={Cart.showModal} fullContentWidth>
	<div class="h-full flex flex-col">
		<div class="grow shrink px-4 md:px-12 overflow-y-auto flex flex-col gap-8 sm:gap-4 pb-10">
			{#each Cart.orderProducts as orderProduct (orderProduct.id)}
				<CartOverviewProduct {orderProduct} />
			{:else}
				<div class="text-center mt-10 items-center flex flex-col gap-4">
					<Icon icon={cofeeBeanIcon} class="size-12 text-fcrbrown" />
					<span class="font-antipol text-fcrdarkbrown font-medium text-6">
						<Formatted text={translate("cartEmpty")} />
					</span>
					<Link
						href={getCategoryPath(tenant.locale, CategoryType.Coffee)}
						size={ButtonSize.Medium}
						variant={ButtonVariant.Dark}
						class="mt-4"
					>
						<Formatted text={translate("currentOffer")} />
					</Link>
				</div>
			{/each}
		</div>
		<div
			class="grow-0 shrink-0 bg-fcrbeige px-4 md:px-12 pb-[max(env(safe-area-inset-bottom,0),0.5rem)] xl:pb-4 2xl:pb-6 sticky md:static w-full z-10 bottom-0"
		>
			<div
				class="flex justify-between items-center text-fcrdarkgray font-medium py-4 2xl:py-6 border-b border-fcrlightgray"
			>
				<div class="text-4">
					<Formatted text={translate("totalWithVat")} />
				</div>
				<div class="text-5.5">
					{#if Cart.currency !== undefined && Cart.totalPrice}
						<Formatted text={formatPrice(Cart.totalPrice.withTax, Cart.currency, tenant.locale, true)} />
					{/if}
				</div>
			</div>
			<CartClosestBenefit />
			{#if Cart.orderProducts.length > 0}
				<Link
					href={getCartPath(tenant)}
					size={isDesktop.current ? ButtonSize.Large : ButtonSize.Medium}
					variant={ButtonVariant.Dark}
					class="w-full mt-4 xl:mt-7 2xl:mt-10"
				>
					<Formatted text={translate("continueToCheckout")} />
				</Link>
			{/if}
		</div>
	</div>
</SideModal>
